import * as React from 'react';
import Anchor from '@telia-front/anchor';
import { useTheme } from '@telia-front/theme-provider';
import DiilLogo from './diil-logo';
import GreenITLogo from './greenit-logo';
import SimpelLogo from './simpel-logo';
import SuperLogo from './super-logo';
import TeliaLogo from './telia-logo';
const Logo = ({ theme, color: propColor, className, size, text, url, target, onClick }) => {
    const { brand } = useTheme();
    const color = propColor !== null && propColor !== void 0 ? propColor : (theme === 'stealth' ? 'neutral' : undefined);
    const BEM = () => {
        const classArray = ['logo'];
        if (color) {
            classArray.push(`logo--color-${color}`);
        }
        if (size) {
            classArray.push(`logo--${size}`);
        }
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    const logo = React.useMemo(() => {
        switch (brand) {
            case 'super':
                return React.createElement(SuperLogo, { className: "logo__img", title: text });
            case 'diil':
                return React.createElement(DiilLogo, { className: "logo__img", title: text });
            case 'simpel':
                return React.createElement(SimpelLogo, { className: "logo__img", title: text });
            case 'greenit':
                return React.createElement(GreenITLogo, { className: "logo__img", title: text });
            case 'telia':
            default:
                return React.createElement(TeliaLogo, { className: "logo__img", title: text });
        }
    }, [text, brand]);
    return (React.createElement("span", { className: BEM(), "data-theme": theme === 'stealth' ? undefined : theme }, url ? (React.createElement(Anchor, { url: url, className: "logo__img", onClick: onClick, target: target }, logo)) : (logo)));
};
export { Logo as default };
